import React from 'react';
import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import GraficaPA from './graficapa';
import Tooltip from '@material-ui/core/Tooltip';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(15),
        border: '1px solid #dadde9',
    },
}))(Tooltip);


export default function ChartPa({ data, dataD, fechaIni, fechaFin, valorTotal }) {
    const series = [
        dataD[0]?.value1 === undefined ? 0 : dataD[0].value1,
        dataD[1]?.value2 === undefined ? 0 : dataD[1].value2,
        dataD[2]?.value3 === undefined ? 0 : dataD[2].value3,
        dataD[3]?.value4 === undefined ? 0 : dataD[3].value4,
        dataD[4]?.value5 === undefined ? 0 : dataD[4].value5,
        dataD[5]?.value6 === undefined ? 0 : dataD[5].value6,
    ];

    return (
        <>
            <Grid container spacing={2} alignItems="center" justifyContent="center">
                <Grid item>
                    <Grid item xs={12} sm container>
                        <Grid item xs container>
                            <Grid item xs>
                                <Grid item xs={12} sm container alignItems="center">
                                    <Grid item xs={12} sm container alignItems="center">
                                        <Typography align="center" alignItems="center" style={{ fontWeight: 'bold', fontSize: "30px" }}color='primary'>
                                            Presión Arterial
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container spacing={2} alignItems="start" justifyContent="center" style={{ marginTop: '0%', marginLeft: "8px", width: '100%', height: '150px' }}>
                <Grid item>
                    <Grid item xs={3} sm container>
                        <Grid item xs container direction="column">
                            <Grid item xs={12} md={12} lg={12}>
                                <GraficaPA series={series} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={3} style={{ marginLeft: '70%',marginTop:'-22%' ,zIndex:500}}>
                <div style={{ display: 'flex', flexDirection: 'column'  }}>
                        <div style={{ marginBottom: '10px' }}>
                            <div style={{ height: '22px' }}>
                                <HtmlTooltip
                                    title={
                                        <React.Fragment>
                                            <Typography>Descripción</Typography>
                                            <b><br />{"HIPOTENSIÓN:"}</b>{' '}
                                            {"Valores menores a 40 y 50."}
                                        </React.Fragment>
                                    }
                                    placement="right-start"
                                >
                                    <HelpOutlineIcon style={{height: '21px' }} color='primary' />
                                </HtmlTooltip>
                            </div>
                            <div style={{ height: '22px' }}>
                                <HtmlTooltip
                                    title={
                                        <React.Fragment>
                                            <Typography>Descripción</Typography>
                                            <b><br />{"ÓPTIMA:"}</b>{' '}
                                            {"Valores de tensión entre 50 y 80 en Diastólica o entre 60 y 120 en Sistólica."}
                                        </React.Fragment>
                                    }
                                    placement="right-start"
                                >
                                    <HelpOutlineIcon style={{height: '21px' }} color='primary' />
                                </HtmlTooltip>
                            </div>
                            <div style={{ height: '22px' }}>
                                <HtmlTooltip
                                    title={
                                        <React.Fragment>
                                            <Typography>Descripción</Typography>
                                            <b><br />{"NORMAL:"}</b>{' '}
                                            {"Valores de tensión entre 80 y 85 en Diastólica o entre 120 y 130 en Sistólica"}
                                        </React.Fragment>
                                    }
                                    placement="right-start"
                                >
                                    <HelpOutlineIcon style={{height: '21px' }} color='primary'/>
                                </HtmlTooltip>
                            </div>
                            <div style={{ height: '22px' }}>
                                <HtmlTooltip
                                    title={
                                        <React.Fragment>
                                            <Typography>Descripción</Typography>
                                            <b><br />{"SOSPECHA:"}</b>{' '}
                                            {"Valores de tensión entre 85 y 90 en Diastólica o entre 130 y 140 en Sistólica"}
                                        </React.Fragment>
                                    }
                                    placement="right-start"
                                >
                                    <HelpOutlineIcon style={{ height: '21px' }} color='primary' />
                                </HtmlTooltip>
                            </div>
                            <div style={{ height: '22px' }}>
                                <HtmlTooltip
                                    title={
                                        <React.Fragment>
                                            <Typography>Descripción</Typography>
                                            <b><br />{"HIPERTENSIÓN ARTERIAL:"}</b>{' '}
                                            {"Valores de tensión mayores o iguales a 90 en Diastólica o mayores o iguales a 140 en Sistólica."}
                                        </React.Fragment>
                                    }
                                    placement="right-start"
                                >
                                    <HelpOutlineIcon style={{height: '21px' }} color='primary' />
                                </HtmlTooltip>
                            </div>
                            <div style={{ height: '22px' }}>
                                <HtmlTooltip
                                    title={
                                        <React.Fragment>
                                            <Typography>Descripción</Typography>
                                            <b><br />{"SIN REGISTRO:"}</b>{' '}
                                            {"Usuarios que no se han realizado las mediciones de presión arterial en la estación de tele salud."}
                                        </React.Fragment>
                                    }
                                    placement="right-start"
                                >
                                    <HelpOutlineIcon style={{height: '21px' }} color='primary' />
                                </HtmlTooltip>
                            </div>
                        </div>
                    </div>
                </Grid>
            </Grid>
        </>
    );
}
